import React, { useContext, useState, useEffect } from 'react';
import { AlumnosContext } from '../../../context/alumnos/AlumnosContext';
import Avatar from '../../Tabla/Avatar';
import Formulario from './Formulario';
import BulkUpdateModal from './BulkUpdateModal';
import FiltrosAlumnos from './FiltrosAlumnos';
import Spinner from '../../Layout/Spinner';

export default function TablaAlumnos() {
	const alumnoCtx = useContext(AlumnosContext);
	const { alumnos, getAlumnos, createAlumno, updateAlumno, data, clearFormData, loading } = alumnoCtx;

	useEffect(() => {
		getAlumnos();
	}, [getAlumnos]);

	const [selectedAlumnos, setSelectedAlumnos] = useState([]);
	const [alumnosFiltrados, setAlumnosFiltrados] = useState([]);
    const [filtros, setFiltros] = useState({
        categoria: '',
        nombre: '',
        apellido: '',
        grupo: '',
        añoNacimiento: ''
    });
	const [showModal, setShowModal] = useState(false);
	const [showBulkModal, setShowBulkModal] = useState(false);
	const [editingId, setEditingId] = useState(null);
	const [verInactivos, setVerInactivos] = useState(false);

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			setSelectedAlumnos(alumnosFiltrados.map((a) => a.id));
		} else {
			setSelectedAlumnos([]);
		}
	};

	const handleSelectOne = (id) => {
		if (selectedAlumnos.includes(id)) {
			setSelectedAlumnos(selectedAlumnos.filter((item) => item !== id));
		} else {
			setSelectedAlumnos([...selectedAlumnos, id]);
		}
	};

	const handleOpenAddModal = () => {
		clearFormData();
		setEditingId(null);
		setShowModal(true);
	};

	const handleOpenEditModal = (id) => {
		setEditingId(id);
		setShowModal(true);
	};

	const toggleVerInactivos = () => {
		const nuevoEstado = !verInactivos;
		setVerInactivos(nuevoEstado);
		getAlumnos(!nuevoEstado);
	};

	const sendData = async (event) => {
		event.preventDefault();
		if (editingId) {
			await updateAlumno(editingId, data);
		} else {
			await createAlumno(data);
		}
		setShowModal(false);
	};

	return (
		<div style={{ margin: '10px' }}>
			<FiltrosAlumnos 
				alumnos={alumnos} 
				filtros={filtros} 
				setFiltros={setFiltros} 
				setAlumnosFiltrados={setAlumnosFiltrados} 
			/>

			<div className='d-flex justify-content-left align-items-center mb-3 gap-2'>
				<button
					className='btn btn-success'
					onClick={handleOpenAddModal}
				>
					Agregar Alumno
				</button>
				<button
					className={verInactivos ? 'btn btn-primary' : 'btn btn-secondary'}
					onClick={toggleVerInactivos}
				>
					{verInactivos ? 'Ver Activos' : 'Ver Inactivos'}
				</button>
				{selectedAlumnos.length > 0 && <button
					className='btn btn-success'
					onClick={() => setShowBulkModal(true)}
				>
					Modificar Alumnos
				</button>}
			</div>

			<table className='table table-striped fluid'>
				<thead>
					<tr>
						<th scope='col'>
							<input
								type='checkbox'
								onChange={handleSelectAll}
								checked={
									alumnosFiltrados.length > 0 &&
									selectedAlumnos.length === alumnosFiltrados.length
								}
							/>
						</th>
						<th scope='col'>FOTO</th>
						<th scope='col'>NOMBRE</th>
						<th scope='col'>APELLIDO</th>
						<th scope='col'>AÑO NACIMIENTO</th>
						<th scope='col'>CATEGORIA</th>
						<th scope='col'>GRUPO</th>
						<th scope='col'>ACCIONES</th>
					</tr>
				</thead>
				<tbody>
					{loading ? (
						<tr>
							<td colSpan={8}>
								<Spinner />
							</td>
						</tr>
					) : (
						alumnosFiltrados.map((alumno) => {
							const añoNacimiento = alumno.fechaNacimiento
								? new Date(alumno.fechaNacimiento).getFullYear()
								: '-';
							return (
								<tr key={alumno.id}>
									<td>
										<input
											type='checkbox'
											checked={selectedAlumnos.includes(alumno.id)}
											onChange={() => handleSelectOne(alumno.id)}
										/>
									</td>
									<td>
										<Avatar
											width='40px'
											src={alumno.avatar}
											alt={`avatar ${alumno.nombre} ${alumno.apellido}`}
										/>
									</td>
									<td>{alumno.nombre}</td>
									<td>{alumno.apellido}</td>
									<td>{añoNacimiento}</td>
									<td>{alumno.categoria}</td>
									<td>{alumno.grupo || '-'}</td>
									<td>
										<button
											className='btn btn-primary'
											onClick={() => handleOpenEditModal(alumno.id)}
										>
											Editar
										</button>
									</td>
								</tr>
							);
						})
					)}
				</tbody>
			</table>

			{/* Bootstrap Modal */}
			{showModal && (
				<div
					className='modal fade show'
					style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
					tabIndex='-1'
				>
					<div className='modal-dialog modal-lg'>
						<div className='modal-content'>
							<div className='modal-header'>
								<h5 className='modal-title'>
									{editingId ? 'Editar Alumno' : 'Nuevo Alumno'}
								</h5>
								<button
									type='button'
									className='btn-close'
									onClick={() => setShowModal(false)}
								></button>
							</div>
							<div className='modal-body'>
								<Formulario 
									titulo={editingId ? 'Editar Alumno' : 'Crear nuevo alumno'} 
									handleSubmit={sendData} 
									alumnoId={editingId}
								/>
							</div>
						</div>
					</div>
				</div>
			)}

			<BulkUpdateModal
				isOpen={showBulkModal}
				onClose={() => setShowBulkModal(false)}
				selectedIds={selectedAlumnos}
			/>
		</div>
	);
}
